module.exports = __webpack_public_path__ + "img/bras_3kl.0c7c0d77.jpg";